export const apiUrls = {
        "country": "/api/CountrySearch/getcountries",
        "ships-agency": "/api/PortSearch/GetPorts",
        "maritime-logistics": "/api/MaritimeLogisticsOfficeSearch/GetOffices",
        "marine-products": "/api/MarineProductsOfficeSearch/GetOffices",
        "people": "/api/PeopleSearch/GetPeople",
    };

export const scrollbarOptions = {
  wheelPropagation: false,
  minScrollbarLength: 20,
  maxScrollbarLength: 20,
  suppressScrollX: true,
  swipeEasing: false,
};

export const suggestionMessages = {
    start: "Start typing...",
    noResults: "No results found",
    enterMore: "Enter more than 3 characters"
};

export const delay = 250;